import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { ShieldCheck } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="w-full bg-dark py-24 relative overflow-hidden" data-id="element-154">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-cyan-accent/5 rounded-full blur-[150px] pointer-events-none" data-id="element-155"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-156">
        <FadeIn data-id="element-157">
          <div className="text-center mb-12" data-id="element-158">
            <h2 className="font-display text-4xl md:text-5xl font-bold uppercase mb-6" data-id="element-159">
              Reclaim Your <span className="text-cyan-accent" data-id="element-160">Mobility</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-161">
              Reclaiming your mobility shouldn't cost as much as a new ergonomic
              chair. Get the entire protocol today for less than the price of a
              single physical therapy co-pay.
            </p>
          </div>

          <div className="bg-dark-panel border-2 border-cyan-accent/50 p-8 md:p-12 max-w-2xl mx-auto relative shadow-[0_0_50px_rgba(0,212,255,0.1)]" data-id="element-162">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-cyan-accent text-dark font-display font-bold uppercase px-6 py-2 text-sm tracking-widest" data-id="element-163">
              Instant Digital Access
            </div>

            <div className="text-center mb-8 mt-4" data-id="element-164">
              <div className="text-gray-500 line-through text-2xl font-display mb-2" data-id="element-165">
                Regular Value: $19
              </div>
              <div className="text-sm font-display uppercase tracking-widest text-cyan-accent mb-2" data-id="element-166">
                Oferta Especial
              </div>
              <div className="text-6xl md:text-7xl font-display font-bold text-white flex items-start justify-center" data-id="element-167">
                <span className="text-3xl mt-2 mr-1 text-cyan-accent" data-id="element-168">$</span>
                6.39
              </div>
            </div>

            <div className="flex flex-col items-center" data-id="element-169">
              <CTAButton text="Download the Matrix Now" subtext="Instant PDF access. Start your first 8-minute reset immediately." className="w-full py-5 text-2xl" data-id="element-170" />

              <div className="flex items-center justify-center gap-2 mt-6 text-gray-500 text-sm" data-id="element-171">
                <ShieldCheck className="w-4 h-4" data-id="element-172" />
                <span data-id="element-173">Secure, encrypted checkout</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}